import "./VerifyOtp.scss";
import Loader from "components/elements/Loader/Loader";
import {
  ChangeEventHandler,
  FormEventHandler,
  useEffect,
  useMemo,
  useState,
} from "react";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import {
  apiRequest,
  getClientIP,
  getOnboarding,
  setOnboarding,
  setUser,
} from "utils/service";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
} from "react-device-detect";

const VerifyOtp = () => {
  const onboardingData = getOnboarding();
  const [, forceUpdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    otp: "",
    cell: onboardingData.mobile,
    imei: "",
    device_name: osName,
    modal_no: osVersion,
    browser_info: browserName + " " + browserVersion,
    os_version: osVersion,
  });
  const validator = useMemo(
    () =>
      new SimpleReactValidator({
        autoForceUpdate: { forceUpdate },
      }),
    [forceUpdate]
  );

  const handleFormSubmit: FormEventHandler = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      setLoading(true);
      apiRequest("verify_otp", formData)
        .then((resp) => {
          if (resp.success === "true") {
            toast.success(resp.message);
            const updatedOnboardingData = { path: "exam-type" };
            setOnboarding(updatedOnboardingData);
            setUser(resp);
            window.location.href = updatedOnboardingData.path;
          } else {
            toast.error(resp.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      validator.showMessages();
    }
  };

  const resendOtp = () => {
    setLoading(true);
    apiRequest("generate_otp", { email_cell: formData.cell })
      .then((resp) => {
        toast.success(resp.message);
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getClientIP().then((ip) => {
      setFormData((prevState) => ({ ...prevState, imei: ip }));
    });
  }, []);

  return (
    <div className="login-container">
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header">
            <h3>Verify OTP</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleFormSubmit}>
              <div className="row">
                <div className="col-8 offset-2">

                  <div className="input-group form-group mb-3 d-flex">
                    <div className="d-flex w-100">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-mobile"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        name="otp"
                        value={formData.otp}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter OTP"
                        maxLength={4}
                      />
                    </div>
                    {validator.message(
                      "otp",
                      formData.otp,
                      "required|numeric|min:4|max:4",
                      { className: "text-danger" }
                    )}
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      onClick={resendOtp}
                      disabled={loading}
                      className="btn btn-link text-warning"
                    >
                      Resend OTP?
                    </button>
                  </div>
                  <div className="form-group">
                    <input
                      disabled={loading}
                      type="submit"
                      value="Submit"
                      className="btn float-right login_btn"
                    />
                  </div>
                </div>
              </div>


            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
